import { render } from "./TicketDetail.vue?vue&type=template&id=5c9ca098"
import script from "./TicketDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketDetail.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Reporting/TicketDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c9ca098"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c9ca098', __exports__)) {
    api.reload('5c9ca098', __exports__)
  }
  
  module.hot.accept("./TicketDetail.vue?vue&type=template&id=5c9ca098", () => {
    api.rerender('5c9ca098', render)
  })

}


export default __exports__